import Swiper, { Navigation, Scrollbar } from 'swiper';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';
import '@/modules/carousel/carousel.css';

export default class TestimonialCarousel {
    constructor(el) {
        if (!el.querySelector('.swiper')) return;
        this.el = el;

        this.init();
    }

    init () {
        new Swiper(this.el.querySelector('.swiper'), {
            modules: [Navigation, Scrollbar],
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: {
                nextEl: this.el.querySelector('.js-swiper-custom-button-next'),
                prevEl: this.el.querySelector('.js-swiper-custom-button-prev')
            },
            scrollbar: {
                el: this.el.querySelector('.swiper-scrollbar'),
                draggable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: 3
                }
            }
        });
    }
}
